import { saveExcel } from "../../../utils/saveExcel";
import { useDispatch } from "react-redux";
import { downloadExecutiveList } from "../../../actionCreator/executiveListingActionCreater";
import { savePDF } from "../../../utils";
import { useAlert } from "../../../context/AlertProvider";
import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";

const columns = [
  { header: "Serial No.", key: "serealNo" },
  { header: "FirstName", key: "firstName" },
  { header: "LastName", key: "lastName" },
  { header: "Designation", key: "designation" },
  { header: "Email Available", key: "email" },
  { header: "Company Name", key: "name" },
  { header: "Phone", key: "phoneNo" },
  { header: "Address", key: "address" },
  { header: "City", key: "city" },
  { header: "State", key: "state" },
  { header: "Country", key: "country" },
  { header: "Pin", key: "pincode" },
  { header: "Website", key: "wedsite" },
  { header: "Industry", key: "industryName" },
];

export const useExport = () => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const { isAuthenticated } = useContext(AuthContext);

  const onExport = async (selectedRecords, type) => {
    if (isAuthenticated) {
      if (selectedRecords.length) {
        const res = await dispatch(
          downloadExecutiveList(selectedRecords, type),
        );
        if (res?.length) {
          const downloadedUpdatedData = getSchema(res);
          const fileName = "Executive Data";
          if (type === "exl") {
            saveExcel(downloadedUpdatedData, columns, fileName);
          } else {
            savePDF(downloadedUpdatedData, columns, fileName);
          }
          showAlert(
            "success",
            "Download Complete",
            <div>
              Your Executive Data has been successfully downloaded to{" "}
              {type === "exl" ? (
                <FileExcelOutlined style={{ color: "#4CAF50" }} />
              ) : (
                <FilePdfOutlined style={{ color: "#f44336" }} />
              )}
              .
            </div>,
          );
        }
      } else {
        showAlert("warning", "please select record.");
      }
    }
  };

  const getSchema = (data) => {
    var finaldata = [];
    let cnt = 0;
    data.forEach((obj) => {
      cnt++;
      var dataObj = {};
      dataObj.id = obj.id;
      dataObj.serealNo = cnt;
      dataObj.firstName = obj.firstname;
      dataObj.lastName = obj.lastname;
      dataObj.designation = obj.title;
      dataObj.email = obj.emailId;
      dataObj.name = obj?.company?.name;
      dataObj.revenueName = obj?.company?.revenue?.name;
      dataObj.employeeRange = obj?.company?.range?.name;
      dataObj.industryName = obj?.company?.industry?.name;
      dataObj.country = obj?.company?.country;
      dataObj.state = obj?.company?.state;
      dataObj.city = obj?.company?.city;
      dataObj.wedsite = obj?.company?.wedsite;
      dataObj.address = obj?.company?.address;
      dataObj.pincode = obj?.company?.pincode;
      dataObj.phoneNo = obj?.company?.phoneNo;
      finaldata.push(dataObj);
    });
    return finaldata;
  };

  return { onExport, getSchema, columns };
};
